import { Address } from './_models';
import Cookies from 'js-cookie';
import { v4 as uuid } from 'uuid';
import { useEffect } from 'react';
import axios from 'axios';

const API_URL = import.meta.env.VITE_APP_API_URL;

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export function humanFileSize(bytes: number, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

  return bytes.toFixed(dp) + ' ' + units[u];
}

export function capitalize(s: string | undefined) {
  return s && s[0].toUpperCase() + s.slice(1);
}

export function googleToLMAddress(place: any) {
  const componentsTranslator = {
    street_number: 'street_number',
    route: 'street',
    country: 'country',
    postal_code: 'zip_code',
    locality: 'city'
  };

  const address: Address = {};
  // Convert properties using the translator
  for (const componentIndex in place.address_components) {
    const component = place.address_components[componentIndex];

    for (const keyIndex in component.types) {
      const key = component.types[keyIndex];

      // @ts-expect-error
      if (componentsTranslator[key]) {
        // @ts-expect-error
        address[componentsTranslator[key]] = component.long_name;
      }
    }
  }

  address['latitude'] = place.geometry.location.lat();
  address['longitude'] = place.geometry.location.lng();

  return address;
}

export function LMAddressToString(address: Address) {
  return `${address.street_number} ${address.street}, ${address.zip_code} ${address.city}, ${address.country}`;
}

export function useFbclid() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
      sessionStorage.setItem('fbclid', fbclid);
    }
  }, []);
}

export function trackConversionEvent(
  pixelId: string | undefined,
  organizationId: string | null,
  eventName: string,
  data?: any
) {
  // @ts-expect-error
  if (pixelId && window.fbq) {
    const uniqid = uuid();
    // @ts-expect-error
    window.fbq('init', pixelId);
    // @ts-expect-error
    window.fbq('trackCustom', eventName, data, { eventID: uniqid });
    axios.post(API_URL + '/api/marketing/conversion/', {
      event_name: eventName,
      organization_id: organizationId,
      source_url: window.location.href,
      event_data: data,
      pixel_id: pixelId,
      event_id: uniqid,
      fbclid: sessionStorage.getItem('fbclid') || null,
      fbc: Cookies.get('_fbc') || null,
      fbp: Cookies.get('_fbp') || null
    });
  }
}
